import React from 'react';

// Import all icons
import gridIcon from '../assets/icons/grid.svg';
import peopleIcon from '../assets/icons/people.svg';
import cardIcon from '../assets/icons/card.svg';
import playIcon from '../assets/icons/play.svg';
import giftIcon from '../assets/icons/gift.svg';
import settingsIcon from '../assets/icons/settings.svg';
import leaveIcon from '../assets/icons/leave.svg';
import activityIcon from '../assets/icons/activity.svg';
import pointsIcon from '../assets/icons/points.svg';
import upDownIcon from '../assets/icons/up-down.svg';
import searchIcon from '../assets/icons/search.svg';
import ticketIcon from '../assets/icons/ticket.svg';
import checkmarkIcon from '../assets/icons/checkmark.svg';
import chevronLeftIcon from '../assets/icons/chevron-left.svg';
import hammerIcon from '../assets/icons/hammer.svg';
import bellIcon from '../assets/icons/bell.svg';
import dollarSignIcon from '../assets/icons/dollar-sign.svg';
import trendingIcon from '../assets/icons/trending.svg';
import extensionIcon from '../assets/icons/extension.svg';

const iconMap = {
  grid: gridIcon,
  people: peopleIcon,
  card: cardIcon,
  play: playIcon,
  gift: giftIcon,
  settings: settingsIcon,
  leave: leaveIcon,
  activity: activityIcon,
  points: pointsIcon,
  'up-down': upDownIcon,
  search: searchIcon,
  ticket: ticketIcon,
  checkmark: checkmarkIcon,
  'chevron-left': chevronLeftIcon,
  hammer: hammerIcon,
  bell: bellIcon,
  'dollar-sign': dollarSignIcon,
  trending: trendingIcon,
};

const Icon = ({ name, size = 18, className = '' }) => {
  const iconSrc = iconMap[name];

  if (!iconSrc) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <img
      src={iconSrc}
      alt={name}
      width={size}
      height={size}
      className={className}
    />
  );
};

export default Icon;